const URL = (process.env.REACT_APP_API_BASE_URL || "http://localhost:7100/api/").replace(/\/+$/, "") + "/";

const apiPath = {
  baseURL: URL,

  // Auth
  login: "employee/auth/login",
  teamsSso: "employee/auth/teams-sso",
  forgotPassword: "employee/auth/forgot-password",
  resetPassword: "employee/auth/reset-password",
  profile: "employee/auth/profile",
  profilePicture: "employee/auth/profile/picture",
  workMode: "employee/auth/work-mode",

  // Attendance
  attendanceLogin: "employee/attendance/login",
  locationCheck: "employee/attendance/location-check",
  attendanceLogout: "employee/attendance/logout",
  attendanceToday: "employee/attendance/today",
  attendanceHistory: "employee/attendance/history",
  attendanceMonth: "employee/attendance/month",
  attendanceDayStatus: "employee/attendance/day-status",
  breakStart: "employee/attendance/break/start",
  breakEnd: "employee/attendance/break/end",

  // Holidays
  holidays: "employee/holidays",

  // Policies
  policies: "employee/policies",

  // Leave Requests
  leaveRequests: "employee/leave-requests",
  leaveRequestsMine: "employee/leave-requests/mine",
  leaveRequestDocumentDownload: (id) => `employee/leave-requests/${id}/document/download`,

  // WFH Requests
  wfhRequests: "employee/wfh-requests",
  wfhRequestsMine: "employee/wfh-requests/mine",

  // Payslips
  payslips: "employee/payslips",
  payslipDownload: (id) => `employee/payslips/${id}/download`,

  // Reimbursements
  reimbursements: "employee/reimbursements",
  reimbursementsMine: "employee/reimbursements/mine",
  reimbursementBill: (id) => `employee/reimbursements/${id}/bill`,
  reimbursementBillDownload: (id) => `employee/reimbursements/${id}/bill/download`,

  // Overtime
  overtime: "employee/overtime",
  overtimeMine: "employee/overtime/mine",

  // Notifications
  notifications: "employee/notifications",
  notificationRead: (id) => `employee/notifications/${id}/read`,
  notificationReadAll: "employee/notifications/read-all",

  // Web Push
  pushSubscribe: "employee/push/subscribe",
  pushUnsubscribe: "employee/push/unsubscribe",
  vapidPublicKey: "push/vapid-public-key",
};

export default apiPath;
